import {
  Breadcrumb,
  Button,
  Input,
  message,
  PageHeader,
  Select,
  Form,
  Row,
  Col,
  Table,
  Divider,
  Tag,
  Popconfirm,
} from "antd";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Page from "_components/Page";
import { Auth } from "_helpers";
import { companyService, jobService } from "_services";
import TabMenu from "./TabMenu";

function Summary({ history, match }) {
  const { id } = match.params;
  const { path } = match;
  const [isLoading, setIsLoading] = useState(false);
  const [loadingStatusUpdate, setLoadingStatusUpdate] = useState(false);
  const [item, setItem] = useState({});
  const [stores, setStores] = useState([]);
  const [storeAddresses, setStoreAddresses] = useState([]);
  const [form] = Form.useForm();
  const { Option } = Select;

  useEffect(() => {
    setIsLoading(true);
    companyService.getSuggestion("?companyType=STORE").then((x) => {
      if (x.content.length === 1) {
        let companyId = Auth.getProfile().comp_id
          ? Auth.getProfile().comp_id
          : x.content[0].id;
        companyService.getById(companyId).then((data) => {
          const grantedStoreAddresses = data.content.addresses.filter(
            (item) => item.addressType === "WAREHOUSE"
          );
          setStoreAddresses(grantedStoreAddresses);
        });
      }
      setStores(x.content);
    });

    jobService
      .getById(id)
      .then((x) => {
        setIsLoading(false);
        setItem(x.content);
        onFill(x.content);
      })
      .catch((errorInfo) => {
        setIsLoading(false);
        message.error(`${errorInfo}`);
      });
  }, []);

  const handleFormSumbit = () => {
    form
      .validateFields()
      .then((values) => {
        setIsLoading(true);
        jobService
          .update(id, values)
          .then(() => {
            message.success("Successfully updated!");
            setIsLoading(false);
            history.push(`${path}`.replace(":id", id));
          })
          .catch((error) => {
            setIsLoading(false);
            message.error(`${error}`);
          });
      })
      .catch((error) => {
        message.error(`${error}`);
      });
  };

  const handleStatusUpdate = (status) => {
    setLoadingStatusUpdate(true);
    item.jobStatus = status;
    jobService
      .update(item.id, item)
      .then(() => {
        setLoadingStatusUpdate(false);
        message.success("Successfully started!");
        window.location.reload();
      })
      .catch((error) => {
        setLoadingStatusUpdate(false);
        message.error(`${error}`);
      });
  };

  const onFill = (data) => {
    form.setFieldsValue(data);
  };

  const onCancel = () => {
    history.push("/jobs");
  };

  const getActionButtons = () => {
    let buttons = [];
    if (Auth.hasRole(Auth.getProfile(), ["SAU", "CAU"])) {
      if (item.jobStatus === "OPEN") {
        buttons.push(
          <Popconfirm
            title="Are you sure to start?"
            onConfirm={() => handleStatusUpdate("IN_PROGRESS")}
            key="con-start"
          >
            <Button
              key="btn-start"
              htmlType="button"
              loading={loadingStatusUpdate}
            >
              Start
            </Button>
          </Popconfirm>
        );
      }

      buttons.push(
        <Button
          key="1"
          type="primary"
          htmlType="submit"
          loading={isLoading}
          onClick={handleFormSumbit}
        >
          Save
        </Button>
      );
    }
    buttons.push(
      <Button key="2" htmlType="button" onClick={onCancel}>
        Cancel
      </Button>
    );
    return buttons;
  };

  const getWorkItemColumns = () => {
    const lineColumns = [];
    lineColumns.push({
      title: "Work Item Code",
      dataIndex: "code",
      key: "code",
    });
    lineColumns.push({
      title: "Description",
      dataIndex: "name",
      key: "name",
    });

    return lineColumns;
  };
  const employeeTableColumns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text, record) => record.name,
    },
    {
      title: "NIC",
      dataIndex: "nic",
      key: "nic",
      render: (text, record) => record.nic ?? "",
    },
    {
      title: "Total Booked Mins",
      dataIndex: "totalBookedMins",
      key: "totalBookedMins",
      render: (text, record) => record.totalBookedMins ?? "-",
    },
    {
      title: "Total Labour Cost",
      dataIndex: "totalLabourCost",
      key: "totalLabourCost",
      render: (text, record) => record.totalLabourCost ?? "-",
    },
  ];

  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/dashboard">Dashboard</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/jobs">Job Search</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={`${path}`}>
                Job : {item.code} ::{" "}
                <Tag
                  color={`${
                    item.jobStatus === "OPEN"
                      ? "#2db7f5"
                      : item.jobStatus === "IN_PROGRESS"
                      ? "#108ee9"
                      : "#87d068"
                  }`}
                >
                  {item.jobStatus}
                </Tag>
              </Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        }
        extra={getActionButtons()}
      >
        <Page inner>
          <TabMenu menu="summary" id={id} />
          <Form
            form={form}
            name="form-create"
            layout="vertical"
            requiredMark={false}
          >
            <Row gutter={24}>
              <Col span={6}>
                <Form.Item
                  name={["store", "id"]}
                  label="Store"
                  rules={[{ required: false, message: "Store is required" }]}
                >
                  <Select placeholder="Please select">
                    {stores.length > 0 &&
                      stores.map((t) => (
                        <Option value={t.id} key={t.id}>
                          {t.name}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name="code"
                  label="Code"
                  rules={[{ required: true, message: "Code is required" }]}
                >
                  <Input placeholder="Code" />
                </Form.Item>
              </Col>
              <Col span={12}></Col>
            </Row>
            <Row gutter={24}>
              <Col span={6}>
                <Form.Item
                  name={["storeAddress", "id"]}
                  label="Store Location"
                  rules={[
                    {
                      required: true,
                      message: "Store location is required",
                    },
                  ]}
                >
                  <Select placeholder="Please select" allowClear>
                    {storeAddresses.length > 0 &&
                      storeAddresses.map((t) => (
                        <Select.Option value={t.id} key={t.id}>
                          {t.address}
                        </Select.Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name="description"
                  label="Description"
                  rules={[
                    { required: true, message: "Description is required" },
                  ]}
                >
                  <Input placeholder="Description" />
                </Form.Item>
              </Col>
              <Col span={12}></Col>
            </Row>
            <Divider orientation="left">Work Items</Divider>
            <Table
              bordered
              pagination={false}
              columns={getWorkItemColumns()}
              dataSource={item.workItems}
            />
            {item.employees?.length > 0 && (
              <>
                <Divider orientation="left">Recourses</Divider>
                <Table
                  bordered
                  loading={isLoading}
                  rowKey="id"
                  size="small"
                  columns={employeeTableColumns}
                  dataSource={item.employees}
                />
              </>
            )}
          </Form>
        </Page>
      </PageHeader>
    </div>
  );
}

export default Summary;
